import React, { memo } from 'react'
import { GatsbyImage as Image, getImage, GatsbyImageProps } from 'gatsby-plugin-image';

const GatsbyImage: React.FC<GatsbyImageProps> = memo(({ image, alt, ...props }) => {

    return (<Image image={getImage(image)} alt={alt || "Activeskin"} {...props} />)
})

export default GatsbyImage